var map = {
	"./bg.ogg": "aPr9",
	"./hero-cv-1.ogg": "mmVA",
	"./hero-cv-2.ogg": "5WsH",
	"./hero-cv-3.ogg": "aRj2",
	"./hero-cv-4.ogg": "irzU",
	"./hero-cv-5.ogg": "VpjS",
	"./hero-cv-6.ogg": "mRGU",
	"./hero-cv-7.ogg": "ddCI",
	"./hero-cv-8.ogg": "C6Ih"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "IxyE";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/common/audio ^\.\/.*\.ogg$
// module id = IxyE
// module chunks = 13